<template>
  <div v-if="api_data.Farmer">
    <div class="card rounded-0 card-custom gutter-b">
      <div class="card-header border-0 pt-5">
        <div class="card-title">
          <div class="card-label">
            <div class="font-weight-bolder">
              {{ $t('Government Scheme Benefits') }}
            </div>
            <span class="text-muted mt-3 font-weight-bold font-size-sm">{{ $t('Information') }}</span>
          </div>
        </div>
      </div>
      <div class="card-body pt-2">
        <div class="d-flex align-items-center">
          <div class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center">
            <label>Photo</label>
            <div class="symbol-label"
                 :style="{ backgroundImage: `url('${api_data.Farmer.gov_photo_file_url}')` }"></div>
            <i v-if="api_data.Farmer.gov_photo_file_url" class="symbol-badge bg-success"></i>
            <i v-else-if="api_data.Farmer.gov_photo_file_url == 'false'" class="symbol-badge bg-danger"></i>
            <i v-else class="symbol-badge bg-danger"></i>
          </div>
          <div>
            <a href="#" class="font-weight-bolder font-size-h5 text-dark-75 text-hover-primary">
              <title-head v-bind:api_data="api_data"></title-head>
            </a>
          </div>
        </div>
        <div class="d-flex align-items-center mt-10">
          <div class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center">
            <label>Ration Card</label>
            <div class="symbol-label"
                 :style="{ backgroundImage: `url('${api_data.Farmer.gov_ration_card_file_url}')` }"></div>
            <i v-if="api_data.Farmer.gov_ration_card_file_url" class="symbol-badge bg-success"></i>
            <i v-else-if="api_data.Farmer.gov_ration_card_file_url == 'false'"
               class="symbol-badge bg-danger"></i>
            <i v-else class="symbol-badge bg-danger"></i>
          </div>
          <div class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center">
            <label>Election Card</label>
            <div class="symbol-label"
                 :style="{ backgroundImage: `url('${api_data.Farmer.gov_election_card_file_url}')` }"></div>
            <i v-if="api_data.Farmer.gov_election_card_file_url" class="symbol-badge bg-success"></i>
            <i v-else-if="api_data.Farmer.gov_election_card_file_url == 'false'"
               class="symbol-badge bg-danger"></i>
            <i v-else class="symbol-badge bg-danger"></i>
          </div>
        </div>
        <div class="d-flex align-items-center mt-10">
          <div class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center">
            <label>Aadhar Card</label>
            <div class="symbol-label"
                 :style="{ backgroundImage: `url('${api_data.Farmer.gov_aadhar_card_file_url}')` }"></div>
            <i v-if="api_data.Farmer.gov_aadhar_card_file_url" class="symbol-badge bg-success"></i>
            <i v-else-if="api_data.Farmer.gov_aadhar_card_file_url == 'false'"
               class="symbol-badge bg-danger"></i>
            <i v-else class="symbol-badge bg-danger"></i>
          </div>
        </div>
        <div class="d-flex align-items-center mt-10">
          <div class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center">
            <label>Income Proof</label>
            <div class="symbol-label"
                 :style="{ backgroundImage: `url('${api_data.Farmer.gov_income_proof_file_url}')` }"></div>
            <i v-if="api_data.Farmer.gov_income_proof_file_url" class="symbol-badge bg-success"></i>
            <i v-else-if="api_data.Farmer.gov_income_proof_file_url == 'false'"
               class="symbol-badge bg-danger"></i>
            <i v-else class="symbol-badge bg-danger"></i>
          </div>
          <div class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center">
            <label>Cast Proof</label>
            <div class="symbol-label"
                 :style="{ backgroundImage: `url('${api_data.Farmer.gov_cast_proof_file_url}')` }"></div>
            <i v-if="api_data.Farmer.gov_cast_proof_file_url" class="symbol-badge bg-success"></i>
            <i v-else-if="api_data.Farmer.gov_cast_proof_file_url == 'false'"
               class="symbol-badge bg-danger"></i>
            <i v-else class="symbol-badge bg-danger"></i>
          </div>
        </div>
        <div class="d-flex align-items-center mt-10">
          <div class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center">
            <label>Bank</label>
            <div class="symbol-label"
                 :style="{ backgroundImage: `url('${api_data.Farmer.gov_bank_file_url}')` }"></div>
            <i v-if="api_data.Farmer.gov_bank_file_url" class="symbol-badge bg-success"></i>
            <i v-else-if="api_data.Farmer.gov_bank_file_url == 'false'"
               class="symbol-badge bg-danger"></i>
            <i v-else class="symbol-badge bg-danger"></i>
          </div>
        </div>
        <label-text
            v-bind:text="api_data.Farmer.gov_aadhar_card_number"
            v-bind:label="'Aadhar Card'"
            v-bind:bg_class="'bg-info'"
        ></label-text>
        <label-text
            v-bind:text="api_data.Farmer.gov_election_card_number"
            v-bind:label="'Election Card'"
            v-bind:bg_class="'bg-info'"
        ></label-text>
        <label-text
            v-bind:text="api_data.Farmer.gov_ration_card_number"
            v-bind:label="'Ration Card'"
            v-bind:bg_class="'bg-info'"
        ></label-text>
        <label-text
            v-bind:text="api_data.Farmer.gov_antyodaya_number"
            v-bind:label="'Antyodaya (Ration Card)'"
            v-bind:bg_class="'bg-info'"
        ></label-text>
        <label-text
            v-bind:text="api_data.Farmer.gov_agratakram_number"
            v-bind:label="'Agratakram (Ration Card)'"
            v-bind:bg_class="'bg-info'"
        ></label-text>
        <label-text
            v-bind:text="api_data.Farmer.gov_bpl_number"
            v-bind:label="'BPL (Ration Card)'"
            v-bind:bg_class="'bg-info'"
        ></label-text>
        <label-text
            v-bind:text="api_data.Farmer.gov_apl_number"
            v-bind:label="'APL (Ration Card)'"
            v-bind:bg_class="'bg-info'"
        ></label-text>
        <label-text
            v-bind:text="api_data.Farmer.gov_bank_account_number"
            v-bind:label="'APL (Ration Card)'"
            v-bind:bg_class="'bg-info'"
        ></label-text>
        <label-text
            v-bind:text="api_data.Farmer.gov_bank_name"
            v-bind:label="'APL (Ration Card)'"
            v-bind:bg_class="'bg-info'"
        ></label-text>
        <label-text
            v-bind:text="api_data.Farmer.gov_cast_certificate_number"
            v-bind:label="'Cast Certificate'"
            v-bind:bg_class="'bg-info'"
        ></label-text>
        <label-text
            v-bind:text="api_data.Farmer.gov_income_certificate_number"
            v-bind:label="'Income Certificate'"
            v-bind:bg_class="'bg-info'"
        ></label-text>
        <label-text
            v-bind:text="api_data.Farmer.gov_surpunch_name"
            v-bind:label="'Surpanch Name'"
            v-bind:bg_class="'bg-info'"
        ></label-text>
        <label-text
            v-bind:text="api_data.Farmer.gov_surpunch_mobile_number"
            v-bind:label="'Surpanch Mobile Number'"
            v-bind:bg_class="'bg-info'"
        ></label-text>
        <label-text
            v-bind:text="api_data.Farmer.gov_talati_name"
            v-bind:label="'Talati Name'"
            v-bind:bg_class="'bg-info'"
        ></label-text>
        <label-text
            v-bind:text="api_data.Farmer.gov_talati_mobile_number"
            v-bind:label="'Talati Mobile Number'"
            v-bind:bg_class="'bg-info'"
        ></label-text>
      </div>
      <div class="card-body pt-2">
        <short-data-from-json
            v-bind:head_title="'Scheme Taken'"
            v-bind:data_in_json="api_data.Farmer.gov_scheme_taken"
        ></short-data-from-json>
        <short-data-from-json
            v-bind:head_title="'Scheme Not Taken'"
            v-bind:data_in_json="api_data.Farmer.gov_scheme_not_taken"
        ></short-data-from-json>
      </div>
    </div>
  </div>
</template>

<script>
import titleHead from "../titleHead";
import shortDataFromJson from "../shortDataFromJson";

export default {
  name: 'show-gov-scheme-information',
  component: [
    titleHead,
    shortDataFromJson
  ],
  props: {
    api_data: Object,
  }
}
</script>
